<template>
  <div class="home">
    <Banner></Banner>
    <ProductService></ProductService>
    <NewsCon></NewsCon>
    <Contactus></Contactus>
  </div>
</template>
<script>
import Banner from "@/components/index/Banner.vue";
import ProductService from "@/components/index/ProductService.vue";
import NewsCon from "@/components/index/NewsCon.vue";
import Contactus from "@/components/index/Contactus.vue";
export default {
  name: "index",
  metaInfo() {
    return {
      title: "广州市化工行业协会",
      meta: [
        {
          name: "keywords",
          content: "广州化工行业协会,专业技术人才,职业技能人才",
        },
        {
          name: "description",
          content:
            "广州市化工行业协会成立于1999年4月，是由广州地区从事化学工业和化工相关产业的生产、经营、储存、设计、服务咨询等企业或事业单位自愿结成的地方性、非营利性的社会组织。",
        },
      ],
    };
  },
  data() {
    return {};
  },
  components: {
    Banner,
    ProductService,
    NewsCon,
    Contactus,
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  min-width: 1180px;
  box-sizing: border-box;
  position: relative;
  padding: 0 0 60px 0;
  // overflow-x: hidden;
  // overflow-y: auto;
}
</style>
